import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { ButtonLink } from '../ui/ButtonLink';
import { ImageSourceBadge } from '../ui/ImageSourceBadge';
import { equipment, equipmentCategories } from '../../data/equipment';
import { heroImages } from '../../data/images';
export function EquipmentPreview() {
  return <section aria-labelledby="equipment-title" className="bg-charcoal" data-id="element-149" data-mp="37cx8zae4e15a">
      <div className="grid lg:grid-cols-2" data-id="element-150" data-mp="8tyqzeg2aq2i">
        <div className="relative min-h-[320px] lg:min-h-[640px]" data-id="element-151" data-mp="8rma74m1ilr1">
          <img src={heroImages.equipment.src} alt={heroImages.equipment.alt} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover object-[70%_center]" data-id="element-152" data-mp="3vncgqetnrdy" />
          <ImageSourceBadge source={heroImages.equipment.source} className="absolute bottom-3 right-3" data-id="element-153" data-mp="2jlruozntvgx3" />
        </div>
        <div className="px-5 py-16 md:px-12 md:py-20 lg:px-16" data-id="element-154" data-mp="2fjn1g21akmaz">
          <SectionHeading id="equipment-title" label="Plant & Equipment" title="Resources on the ground" intro="Plant and equipment from the company schedule, covering earthmoving, road layer works, haulage and building works." data-id="element-155" data-mp="2fmj0jtovlh10" />
          <ul className="mt-10 border-t border-white/15" data-id="element-156" data-mp="gbbup47fgkb0">
            {equipmentCategories.map(category => <li key={category.id} className="border-b border-white/15 py-4" data-id="element-157" data-mp="kcp3nn5th3m5">
                <p className="font-display text-[18px] font-bold uppercase tracking-[0.04em] text-white" data-id="element-158" data-mp="6i4t7uft5og7">{category.title}</p>
                <p className="mt-1 text-[15px] text-steel-300" data-id="element-159" data-mp="3sqnwwh1emavy">
                  {equipment.filter(item => item.category === category.id).map(item => item.name).join(' · ')}
                </p>
              </li>)}
          </ul>
          <ButtonLink to="/plant-equipment" showArrow className="mt-10" data-id="element-160" data-mp="3ooswrfv7m3jr">
            Explore Our Equipment
          </ButtonLink>
        </div>
      </div>
    </section>;
}